export const RESEND_EMAIL = '@REGISTER/RESEND_EMAIL'
export const RESEND_EMAIL_SUCCESS = '@REGISTER/RESEND_EMAIL_SUCCESS'
export const RESEND_EMAIL_ERROR = '@REGISTER/REGISTER_EMAIL_ERROR'
